
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Gauge, Users, FileText, Info, AlertCircle, BrainCircuit } from "lucide-react";
import { Button } from "@/components/ui/button";

export function DashboardInsights() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-xl">
          <Gauge className="h-5 w-5 text-primary" />
          Succession Insights
        </CardTitle>
        <CardDescription>AI-powered recommendations</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {[
            {
              title: "Leadership Gap Identified",
              description: "Your assessment indicates a need for more defined leadership roles for potential successors.",
              icon: <Users className="h-5 w-5 text-primary" />,
              severity: "high",
              action: "Review Team Structure"
            },
            {
              title: "Valuation Consideration",
              description: "Consider obtaining a formal business valuation to establish baseline for succession planning.",
              icon: <Gauge className="h-5 w-5 text-primary" />,
              severity: "medium",
              action: "Start Valuation"
            },
            {
              title: "Buy-Sell Agreement Missing",
              description: "Your business lacks a formal buy-sell agreement, which is critical for ownership transitions.",
              icon: <FileText className="h-5 w-5 text-primary" />,
              severity: "high",
              action: "Create Document"
            },
          ].map((item, index) => (
            <div key={index} className="flex flex-col gap-3 p-3 rounded-md bg-muted/50 border border-border">
              <div className="flex justify-between items-start">
                <div className="bg-primary/10 p-2 rounded-full">
                  {item.icon}
                </div>
                <span className={`px-2 py-1 text-xs rounded-full ${
                  item.severity === "high" 
                    ? "bg-destructive/10 text-destructive" 
                    : item.severity === "medium"
                    ? "bg-warning/10 text-warning"
                    : "bg-success/10 text-success"
                }`}>
                  {item.severity.charAt(0).toUpperCase() + item.severity.slice(1)} Priority
                </span>
              </div>
              <div>
                <h4 className="font-medium">{item.title}</h4>
                <p className="text-sm text-muted-foreground mt-1">
                  {item.description}
                </p>
              </div>
              <Button 
                variant="outline" 
                size="sm" 
                className="mt-auto self-start"
              >
                {item.action}
              </Button>
            </div>
          ))}
          
          <div className="flex items-center justify-center gap-2 text-sm">
            <Info className="h-4 w-4 text-muted-foreground" />
            <span className="text-muted-foreground">
              Insights are based on your assessment responses
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
